import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { ISelection } from '../model/selections/Selection';
import { useParams } from 'react-router-dom';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';


interface useSelectionsResult {
    isLoaded: boolean;
    selections: ISelection[] | null;
}

export const useSelections = () => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();
    const { projectId, gameVersionId } = useParams<{ projectId: string, gameVersionId: string }>();

    const [result, setResult] = useState<useSelectionsResult>({ isLoaded: false, selections: [] });

    useEffect(() => {
        setResult({ isLoaded: false, selections: [] });

        rootStore.selectionStore.loadSelections(false)
            .then(() => {
                setResult({ isLoaded: true, selections: rootStore.selectionStore.selections });
            })
            .catch(e => publishNotification({
                text: 'Error loading selections',
                canClose: true
            }));
    }, [rootStore.selectionStore, publishNotification, projectId, gameVersionId]);

    return result;
};
